import {MiddlewareContext} from '@/lib/middleware'
import {App} from '@/project'
import {RootState} from '@/store'
import {ACTION_NAME} from '@/constants/add-to-home-screen'

/**
 * Runs when the router meta.middleware is 'add-to-home-screen'
 * @param ctx
 */
export function beforeEnter(
  ctx: MiddlewareContext<App, RootState>) {
  const {store, to: {query: {from}}} = ctx

  if(!store) {
    throw new Error('[middleware add-to-home-screen] need to store')
  }

  if(from === 'home-screen') {
    store.commit('userAction/setActions', ACTION_NAME)
    store.dispatch('gtm/logEventWithGroups', {
      eventType: 'shortcut_app_open',
      eventProperties: {},
    })

    store.dispatch('gtm/setUserProperty', {
      event: 'addUserProperty',
      userProperty: {name: 'companyCount', value: store.state.biz?.bizs?.length},
    })
    return ctx.next({
      name: 'home',
      query: {},
    })
  }

  return ctx.next()
}
